// VIDEO LAZYLOAD
let slideDiferenciais,
  sliderHome,
  stories,
  sliderMenuCollection;

document.addEventListener("DOMContentLoaded", function () {
  var lazyVideos = [].slice.call(document.querySelectorAll("video.lazy"));

  if ("IntersectionObserver" in window) {
    var lazyVideoObserver = new IntersectionObserver(function (
      entries,
      observer
    ) {
      entries.forEach(function (video) {
        if (video.isIntersecting) {
          for (var source in video.target.children) {
            var videoSource = video.target.children[source];
            if (
              typeof videoSource.tagName === "string" &&
              videoSource.tagName === "SOURCE"
            ) {
              videoSource.src = videoSource.dataset.src;
            }
          }

          video.target.load();
          video.target.classList.remove("lazy");
          lazyVideoObserver.unobserve(video.target);
        }
      });
    });

    lazyVideos.forEach(function (lazyVideo) {
      lazyVideoObserver.observe(lazyVideo);
    });
  }

  if ($('.compre-look-products-slider').length) {
    var cores = new Swiper(".compre-look-products-slider", {
      slidesPerView: "auto",
      spaceBetween: 0,
      slidesPerGroup: 6,
      loop: false,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        1024: {
          slidesPerView: "auto",
          slidesPerGroup: 6,
          spaceBetween: 0
        }
      }
    });
  }

  if ($('.swiper-calcas').length) {
    var swiperCalcas = new Swiper('.swiper-calcas', {
      slidesPerView: 2.5,
      centerInsufficientSlides: true,
      spaceBetween: 10,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      breakpoints: {
        320: {
          slidesPerView: 2.5,
          spaceBetween: 10
        },
        480: {
          slidesPerView: 2.5,
          spaceBetween: 10
        },
        768: {
          slidesPerView: 3,
          spaceBetween: 10
        },
        1024: {
          slidesPerView: 4,
          spaceBetween: 10
        },
        1200: {
          slidesPerView: 5,
          spaceBetween: 10
        },
        1400: {
          slidesPerView: 6,
          spaceBetween: 10
        }
      }
    });
  }

  slidesDesktop();
});

if ($(window).width() <= 767) {
  $('.slider-collection-menu.swiper-initialized').each(function () {
    this.swiper.destroy(true, true);
  });
}

$(window).on("resize", function () {
  if ($(window).width() <= 767) {
    $('.slider-collection-menu.swiper-initialized').each(function () {
      this.swiper.destroy(true, true);
    });
  } else {
    slidesDesktop();
  }
});

function slidesDesktop() {
  sliderMenuCollection = new Swiper(".slider-collection-menu", {
    slidesPerView: 6.2,
    spaceBetween: 10,
    freeMode: true,
    mousewheel: true,
    pagination: {
      el: ".slider-collection-menu .swiper-pagination",
      type: "progressbar",
    },
    navigation: {
      nextEl: ".slider-collection-menu .swiper-button-next",
      prevEl: ".slider-collection-menu .swiper-button-prev",
    },
  });
}

/*Color swatch nos cards de coleção*/

$(document).on('click', '.thumb-color-meta', function (e) {
  e.preventDefault();
  e.stopPropagation();

  const $clicked = $(this);
  const $containerColor = $clicked.closest('.colors-list-thumbs');
  const $card = $clicked.closest('.card');
  const $productItem = $clicked.closest('.product-item');

  if (!$card.length) return;

  const clickedHandle = $clicked.attr('data-handle');
  const clickedUrl = $clicked.attr('data-url-product') || $clicked.attr('data-product-url');
  const clickedProductUrl = $clicked.attr('data-product-url') || clickedUrl;
  const clickedImage = $clicked.attr('data-image-feature');
  const clickedSecondImage = $clicked.attr('data-second-image');
  const clickedTitle = $clicked.attr('data-product-title');
  const clickedPrice = $clicked.attr('data-price');
  const clickedPriceHtml = $clicked.attr('data-price-html');
  const clickedComparePrice = $clicked.attr('data-compare-price');
  const clickedVariantId = $clicked.attr('data-variant-id');

  if (!clickedHandle || !clickedUrl) return;

  console.group('🟣 CLICK SWATCH CARD');
  console.log('Card atualizado:', $card[0]);
  console.log('Handle clicado:', clickedHandle);
  console.log('URL clicada:', clickedUrl);
  console.log('Imagem principal:', clickedImage);
  console.log('Segunda imagem:', clickedSecondImage);
  console.log('Título:', clickedTitle);
  console.log('Preço:', clickedPrice);
  console.log('Variant ID:', clickedVariantId);

  /**
   * 1. Atualiza estado ativo das bolinhas apenas deste card
   */
  $containerColor.find('.thumb-color-meta').removeClass('active').removeAttr('aria-current');

  $clicked.addClass('active').attr('aria-current', 'true');

  /**
   * 2. Atualiza atributos do product-item atual
   */
  if ($productItem.length) {
    $productItem.attr('data-product-handle', clickedHandle);

    if (clickedVariantId) {
      $productItem.attr('data-variant-id', clickedVariantId);
    }
  }

  /**
   * 3. Atualiza links do card
   * Não altera links dentro das bolinhas.
   */
  $card.find('a[href*="/products/"]').each(function () {
    const $link = $(this);

    if ($link.closest('.colors-list-thumbs').length) return;

    $link.attr('href', clickedUrl);
  });

  /**
   * 4. Atualiza título do produto
   */
  if (clickedTitle) {
    const $titleLink = $card.find(
      '.card-title a, .card__heading a, .card-information a[href*="/products/"], a.full-unstyled-link'
    ).first();

    if ($titleLink.length) {
      $titleLink.text(clickedTitle);
      $titleLink.attr('href', clickedUrl);
    } else {
      const $titleElement = $card.find(
        '.card-title, .card__heading, .card-information__text, .card-product__title'
      ).first();

      if ($titleElement.length) {
        $titleElement.text(clickedTitle);
      }
    }
  }

  /**
   * 5. Atualiza imagens do card
   */
  if (clickedImage) {
    const $images = $card.find('.card-product img, .card__media img, .media img, img.motion-reduce').filter(function () {
      return !$(this).closest('.colors-list-thumbs').length;
    });

    $images.each(function (index) {
      const $image = $(this);
      const nextImage = index === 1 && clickedSecondImage ? clickedSecondImage : clickedImage;

      $image.attr('src', nextImage);
      $image.attr('srcset', '');

      if (clickedTitle) {
        $image.attr('alt', clickedTitle);
      }
    });
  }

  /**
   * 6. Atualiza preço completo
   * Substitui sempre o wrapper inteiro do preço do card.
   * Isso evita acumular preços/parcelamentos antigos a cada troca de cor.
   */
  if (clickedPriceHtml) {
    const $currentPriceBlock = $card.find('.js-card-price').first();

    if ($currentPriceBlock.length) {
      $currentPriceBlock.replaceWith(clickedPriceHtml);
    }
  } else if (clickedPrice) {
    const $priceRegular = $card.find('.js-card-price .price-item').first();

    if ($priceRegular.length) {
      $priceRegular.text(clickedPrice);
    }
  }
  
  /**
   *7. Atualiza formulário/botão de adicionar ao carrinho dentro do card
   */
  if (clickedVariantId) {
    $card.find('input[name="id"]').val(clickedVariantId);

    $card.find('[data-variant-id]').each(function () {
      $(this).attr('data-variant-id', clickedVariantId);
    });

    $card.find('[data-product-id]').each(function () {
      $(this).attr('data-product-id', clickedVariantId);
    });

    $card.find('form[action*="/cart/add"]').each(function () {
      const $form = $(this);
      const $input = $form.find('input[name="id"]');

      if ($input.length) {
        $input.val(clickedVariantId);
      }
    });
  }

  /**
   * 8. Reexecuta funções do tema, se existirem
   */
  window.sliderNavGrid?.();
  window.updateSlideGridProduct?.();

  console.log('Handle ativo final:', $containerColor.find('.thumb-color-meta.active').attr('data-handle'));
  console.groupEnd();
});

function updateArrowVisibility() {
  document.querySelectorAll('.container-colorlist').forEach(function (container) {
    var colorlist = container.querySelector('.colors-list-thumbs');
    var arrow = container.querySelector('.arrow');

    if (arrow) {
      var totalWidth = 0;

      colorlist.querySelectorAll('.thumb-color-meta').forEach(function (color) {
        totalWidth += color.offsetWidth + parseFloat(window.getComputedStyle(color).marginRight);
      });

      if (totalWidth > colorlist.offsetWidth) {
        arrow.style.display = 'block';
      } else {
        arrow.style.display = 'none';
      }
    }
  });
}

document.addEventListener('DOMContentLoaded', function () {
  if (window.__customMobileSubmenuInit) return;
  window.__customMobileSubmenuInit = true;

  document.addEventListener('click', function (event) {
    if (window.innerWidth > 1024) return;

    const lv1Trigger = event.target.closest(
      '.site-nav-mobile[data-navigation-mobile] .js-mobile-submenu-toggle'
    );

    const lv2Trigger = event.target.closest(
      '.site-nav-mobile[data-navigation-mobile] .js-mobile-submenu-toggle-2'
    );

    const trigger = lv1Trigger || lv2Trigger;
    if (!trigger) return;

    const item = trigger.closest(lv1Trigger ? '.menu-lv-1' : '.menu-lv-2');
    if (!item) return;

    const submenu = lv1Trigger
      ? item.querySelector(':scope > .header__submenu.expanded-menu--lv-2.mobile-only')
      : item.querySelector(':scope > .site-nav-list-dropdown > .header__submenu.expanded-menu--lv-3.mobile-only');

    if (!submenu) return;

    event.preventDefault();
    event.stopPropagation();

    const isOpen = item.classList.contains('is-open');

    const siblings = Array.from(item.parentElement.children).filter((el) => el !== item);

    siblings.forEach((sibling) => {
      sibling.classList.remove('is-open');

      sibling.querySelectorAll('.menu-lv-2.is-open').forEach((child) => {
        child.classList.remove('is-open');
      });
    });

    if (isOpen) {
      item.classList.remove('is-open');

      item.querySelectorAll('.menu-lv-2.is-open').forEach((child) => {
        child.classList.remove('is-open');
      });
    } else {
      item.classList.add('is-open');
    }
  });
});